import React, { useEffect, useState } from 'react';
import { Alert, Form, Spinner, Table } from 'react-bootstrap';
import StatusBadge from '../../components/StatusBadge';
import accountApi from '../../services/accountApi';

function unwrapList(data) {
  if (Array.isArray(data)) return { results: data, count: data.length };
  return data || { results: [], count: 0 };
}

function PlatformJobsPage() {
  const [jobs, setJobs] = useState([]);
  const [count, setCount] = useState(0);
  const [statusFilter, setStatusFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {};
      if (statusFilter) params.status = statusFilter;
      const data = unwrapList(await accountApi.listPlatformJobs(params));
      setJobs(data.results || []);
      setCount(data.count ?? (data.results || []).length);
    } catch (err) {
      setError(err.message || 'Failed to load jobs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <h1 className="product-page-title">Jobs</h1>
      <p className="product-page-subtitle">Recent bake jobs across all partners.</p>

      {error && <Alert variant="danger">{error}</Alert>}

      <div className="product-card mb-3">
        <Form
          className="row g-2 align-items-end"
          onSubmit={(e) => {
            e.preventDefault();
            load();
          }}
        >
          <div className="col-md-6">
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="queued">Queued</option>
              <option value="running">Running</option>
              <option value="succeeded">Succeeded</option>
              <option value="failed">Failed</option>
              <option value="cancel_requested">Cancel requested</option>
            </Form.Select>
          </div>
          <div className="col-md-6">
            <button type="submit" className="btn btn-outline-primary w-100">
              Apply
            </button>
          </div>
        </Form>
      </div>

      {loading && (
        <div className="loading-state">
          <Spinner animation="border" size="sm" className="me-2" />
          Loading…
        </div>
      )}

      {!loading && (
        <div className="product-card">
          <div className="small text-muted mb-2">{count} job{count === 1 ? '' : 's'}</div>
          <Table responsive className="product-table" size="sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Status</th>
                <th>Project</th>
                <th>Partner</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map((j) => (
                <tr key={j.id}>
                  <td className="mono">{j.id.slice(0, 8)}…</td>
                  <td>
                    <StatusBadge status={j.status} />
                  </td>
                  <td>{j.project_name || <span className="mono">{j.project_id?.slice(0, 8)}…</span>}</td>
                  <td>{j.partner_name || j.tenant_id?.slice(0, 8) || '—'}</td>
                  <td>{new Date(j.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
}

export default PlatformJobsPage;
